import type { IceText } from '@wpt/iceeditor';

export const getIceTexts = async (host: string): Promise<IceText[] | null> => {
  const response = await fetch(`${host}/iceeditor/ice-texts`);
  if (response.ok) {
    return response.json();
  }
  return null;
};
